var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3UserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.3701 13.0356C31.0263 13.0356 33.1811 10.9102 33.1811 8.28843C33.1811 5.66661 31.0263 3.54126 28.3701 3.54126",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5818 18.1943C31.3751 18.2483 32.1637 18.3593 32.9403 18.5318C34.0192 18.7403 35.3169 19.1768 35.7789 20.1322C36.0737 20.7442 36.0737 21.4566 35.7789 22.0701C35.3184 23.0255 34.0192 23.4605 32.9403 23.6795",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.62952 13.0356C6.97327 13.0356 4.81848 10.9102 4.81848 8.28843C4.81848 5.66661 6.97327 3.54126 9.62952 3.54126",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41774 18.1943C6.62451 18.2483 5.83584 18.3593 5.05933 18.5318C3.98041 18.7403 2.68268 19.1768 2.22224 20.1322C1.92592 20.7442 1.92592 21.4566 2.22224 22.0701C2.68116 23.0255 3.98041 23.4605 5.05933 23.6795",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.992 19.2166C24.3744 19.2166 28.9727 20.0205 28.9727 23.2378C28.9727 26.4535 24.4048 27.2875 18.992 27.2875C13.6081 27.2875 9.01129 26.4835 9.01129 23.2663C9.01129 20.049 13.5792 19.2166 18.992 19.2166Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9921 14.6276C15.4423 14.6276 12.5961 11.8183 12.5961 8.31306C12.5961 4.8093 15.4423 2 18.9921 2C22.5418 2 25.388 4.8093 25.388 8.31306C25.388 11.8183 22.5418 14.6276 18.9921 14.6276Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3UserIcon);
export default __webpack_public_path__ + "static/media/3userIcon.e2db809d9513f99235a2801f83b3ad6f.svg";
export { ForwardRef as ReactComponent };